import React, { Component } from "react";
import { Button } from "react-bootstrap";
import ReactTable from "react-table";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";

export default class TBLTaxas extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.columns = [
      {
        Header: "Estabelecimento",
        accessor: "estabelecimento.nome_fantasia",
        className: "center",
      },
      {
        Header: "Taxa de Operação",
        accessor: "taxa_operacao",
        Cell: (props) => (
          <span>{props.value ? parseFloat(props.value * 100).toFixed(2) : null}%</span>
        ),
        className: "center",
      },
      {
        Header: "Taxa de Manutenção",
        accessor: "taxa_manutencao",
        className: "center",
      },
      {
        Header: "Ações",
        Cell: (row) => {
          return (
            <div>
              <Button
                size="sm"
                style={{ marginRight: 4 }}
                onClick={() => this.gerenciarAcoes("editar", row.row._original)}
              >
                <FontAwesomeIcon icon={faEdit}></FontAwesomeIcon>
              </Button>
              <Button
                size="sm"
                variant="danger"
                onClick={() => this.gerenciarAcoes("deletar", row.row._original)}
              >
                <FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
              </Button>
            </div>
          );
        },
        className: "center",
      },
    ];
  }

  gerenciarAcoes = (tipo, dados) => {
    if (tipo === "editar") {
      this.props.dataCallback(tipo, dados);
    } else if (tipo === "deletar") {
      this.props.dataCallback(tipo, dados);
    } else {
      return;
    }
  };

  render() {
    return (
      <ReactTable
        data={this.props.data}
        className="-striped -highlight"
        columns={this.columns}
        resizable
        style={{ maxHeight: 572 }}
        showPagination={this.props.showPagination}
        defaultPageSize={this.props.numRows}
        previousText="Anterior"
        nextText="Próximo"
        loadingText="Carregando..."
        noDataText="Nenhum dado encontrado!"
        pageText="Página"
        ofText="de"
        rowsText="linhas"
      />
    );
  }
}

TBLTaxas.propTypes = {
  data: PropTypes.array,
  showPagination: PropTypes.bool,
  numRows: PropTypes.number,
  dataCallback: PropTypes.func,
  isDespacho: PropTypes.bool,
};
